import { render, staticRenderFns } from "./EditarContatoRealizadoDialog.vue?vue&type=template&id=088d15d3&"
import script from "./EditarContatoRealizadoDialog.vue?vue&type=script&lang=js&"
export * from "./EditarContatoRealizadoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditarContatoRealizadoDialog.vue"
export default component.exports